<template>
  <div class="order-edit">
    <iframe
      :src="iframeSrc"
      frameborder="0"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<script>
import {computed} from 'vue'
import {useRoute} from 'vue-router'

export default {
  name: 'OrderEdit',
  setup() {
    const route = useRoute()

    const iframeSrc = computed(() => {
      const url = new URL(`https://calc.apex-tech.ru/iframe/order/administer/${useRoute().params.id}/?color=%23e42c31&`)
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
iframe {
  height: calc(100vh - 92px);
  max-width: 100%;
  width: 100%;
}
@media screen and (max-width: 768px) {
  iframe {
    height: calc(100vh - 80px);
  }
}
</style>
